import { memo } from 'react';
import { FixedSizeList as VirtualList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import InfiniteLoader from 'react-window-infinite-loader';

import { Skeleton } from '@conversation-list/skeleton';
import { useConversationListLogic } from './conversation-list.hook';
import {
	LOAD_THRESHOLD,
	CONVERSATION_ITEM_HEIGHT,
	SKELETON_COUNT,
	CONVERSATION_LIST_STRINGS,
} from './utils/conversation-list.constants';
import { ConversationRow } from './conversation-row';

import * as S from './conversation-list.styles';

const ConversationList = memo(() => {
	const {
		viewState,
		loadMoreItems,
		itemData,
		isItemLoaded,
		listItemCount,
	} = useConversationListLogic();

	if (viewState.kind === 'loading') {
		return <Skeleton numOfElements={SKELETON_COUNT} />;
	}

	if (viewState.kind === 'empty') {
		return (
			<S.NoConversation data-qa="no-conversation-message">
				{CONVERSATION_LIST_STRINGS.NO_CONVERSATIONS}
			</S.NoConversation>
		);
	}

	return (
		<AutoSizer>
			{({ height, width }) => (
				<InfiniteLoader
					isItemLoaded={isItemLoaded}
					itemCount={listItemCount}
					loadMoreItems={loadMoreItems}
					threshold={LOAD_THRESHOLD}
				>
					{({ onItemsRendered, ref }) => (
						<VirtualList
							ref={ref}
							height={height}
							width={width}
							itemCount={listItemCount}
							itemSize={CONVERSATION_ITEM_HEIGHT}
							itemData={itemData}
							onItemsRendered={onItemsRendered}
						>
							{ConversationRow}
						</VirtualList>
					)}
				</InfiniteLoader>
			)}
		</AutoSizer>
	);
});

ConversationList.displayName = 'ConversationList';
export { ConversationList };
